var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AutoCompleteAPI from '../classes/GoogleMapAddressAPI';
import { autoCompleteEvents } from 'globals/enums';
import React from 'react';
import { initialStateSelectedAddress, } from './useAutoComplete.types';
import { loadGoogleMapsScript } from 'globals/global.functions';
var autoCompleteAPI = new AutoCompleteAPI();
/**
 * @description Custom hook to use google map autocomplete inside input field.
 * @component useAutoComplete
 * @param {IUseAutoCompleteProps} autocompleteConfig
 * @returns
 */
var useAutoComplete = function (_a) {
    var autocompleteConfig = _a.autocompleteConfig;
    var _b = React.useState(initialStateSelectedAddress), selectedLocation = _b[0], setSelectedLocation = _b[1];
    // Add input listener
    React.useEffect(function () {
        var _a;
        var onChange = autocompleteConfig.onChange, inputRef = autocompleteConfig.inputRef;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keyup', onChange);
        return function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', onChange);
        };
    }, [autocompleteConfig]);
    // Load Maps API and bind autocomplete
    React.useEffect(function () {
        var initialInputValue = autocompleteConfig.initialInputValue, inputRef = autocompleteConfig.inputRef, autocompleteOptions = autocompleteConfig.autocompleteOptions;
        var initAutocomplete = function () { return __awaiter(void 0, void 0, void 0, function () {
            var autoComplete_1, handlePlaceSelect, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loadGoogleMapsScript(process.env.REACT_APP_CARE_PORTAL_GOOGLE_API_KEY || '')];
                    case 1:
                        _a.sent();
                        if (initialInputValue) {
                            inputRef.current.value = initialInputValue;
                        }
                        autoComplete_1 = new google.maps.places.Autocomplete(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current, autocompleteOptions);
                        handlePlaceSelect = function () {
                            var addressDetails = autoCompleteAPI.getAddress(autoComplete_1);
                            inputRef.current.value = addressDetails.streetAddress;
                            setSelectedLocation(addressDetails);
                        };
                        autoComplete_1.addListener(autoCompleteEvents.placeChanged, handlePlaceSelect);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error('Google Maps failed to load in useAutoComplete:', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        initAutocomplete();
    }, [autocompleteConfig]);
    return [selectedLocation];
};
export default useAutoComplete;
